module.exports = __webpack_public_path__ + "static/media/UNES.be5f65f2.svg";